import { render, staticRenderFns } from "./PermissionsLookupsForm.vue?vue&type=template&id=1cfe3897&scoped=true&"
import script from "./PermissionsLookupsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsLookupsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe3897",
  null
  
)

export default component.exports